import { Briefcase, Clock, Moon, Target, type LucideIcon } from "lucide-react";

import { useScreen0Language } from "@/features/language";
import { getTranslations } from "@/i18n";

import { EmphasisText } from "../EmphasisText";

import { BenefitsWaveDivider } from "./BenefitsWaveDivider";

const BENEFIT_ICONS: LucideIcon[] = [Target, Clock, Briefcase, Moon];

export function BenefitsSlide() {
  const { languageCode } = useScreen0Language();
  const t = getTranslations(languageCode);

  return (
    <div className="flex flex-1 flex-col gap-6 pb-4 pt-1">
      <h1 className="text-center text-xl font-semibold leading-snug text-[oklch(90%_0.02_150)] sm:text-[1.35rem]">
        <EmphasisText text={t.onboarding.benefitsHeadline} />
      </h1>

      <BenefitsWaveDivider />

      <ul className="flex flex-col gap-5">
        {t.onboarding.benefits.map((benefit, index) => {
          const Icon = BENEFIT_ICONS[index];

          return (
            <li key={benefit.title} className="flex gap-3.5">
              <span
                className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center text-[oklch(78%_0.12_85)]"
                aria-hidden
              >
                <Icon size={22} strokeWidth={1.75} />
              </span>

              <div className="min-w-0 flex-1">
                <p className="font-semibold leading-snug text-[oklch(90%_0.02_150)]">
                  {benefit.title}
                </p>
                <p className="mt-1 text-sm leading-relaxed text-[oklch(72%_0.025_155)]">
                  {benefit.subtitle}
                </p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
